import React from 'react';
import { useMutation } from 'react-apollo-hooks';
import { changeGroupMembershipPermissions, groupMembersQuery } from '../../../../queries/groups';
import {
  ChangeGroupMembershipPermissions,
  ChangeGroupMembershipPermissionsVariables
} from '../../../../queries/__generated__/ChangeGroupMembershipPermissions';
import { GroupRoleType } from '../../../../__generated__/globalTypes';
import { Switch } from '../../../forms';

interface AdminSwitch {
  group: {
    id: string;
  };
  member: {
    id: string;
    roleType: string;
  };
  disabled?: boolean;
}

const AdminSwitch: React.FC<AdminSwitch> = ({ member, group, disabled }) => {
  const toggleAdminRights = useMutation<
    ChangeGroupMembershipPermissions,
    ChangeGroupMembershipPermissionsVariables
  >(changeGroupMembershipPermissions, {
    variables: {
      input: {
        groupMemberId: member.id,
        roleType:
          member.roleType === GroupRoleType.Admin ? GroupRoleType.Member : GroupRoleType.Admin
      }
    },
    refetchQueries: [
      {
        query: groupMembersQuery,
        variables: { input: { groupId: group.id } }
      }
    ]
  });

  return (
    <Switch
      active={member.roleType.toUpperCase() === 'ADMIN'}
      onClick={toggleAdminRights}
      disabled={disabled}
    />
  );
};

export default AdminSwitch;
